"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomerInterface_1 = require("../../../BusinessLogicLayer/CustomerInterface");
const customerNotificationsQuery_1 = __importDefault(require("./graphql/customerNotificationsQuery"));
const customerNotificationActions_1 = require("./graphql/customerNotificationActions");
class CustomerNotifications {
    constructor(client) {
        this.getCustomerNotifications = async (_token, customerId) => {
            const response = await this.client.post("/graphql", {
                operationName: "coachTrainee",
                query: customerNotificationsQuery_1.default,
                variables: {
                    id: parseInt(customerId),
                },
            });
            const { hasUnseenMeal, hasUnreadMessage, hasUnseenTraining, hasUnseenRecovery, hasUnseenBehaviour, hasUnseenMeasurement, hasUnseenLife, hasUnseenMind, } = response.data.coachTrainee;
            return {
                hasUnseenMeal,
                hasUnreadMessage,
                hasUnseenTraining,
                hasUnseenRecovery,
                hasUnseenBehaviour,
                hasUnseenMeasurement,
                hasUnseenLife,
                hasUnseenMind,
            };
        };
        this.getCustomerActions = async (customerId) => {
            try {
                const response = await this.client.post("/graphql", {
                    operationName: "getCustomersNotificationActions",
                    query: customerNotificationActions_1.notificationActionsQuery,
                    variables: {
                        id: parseInt(customerId),
                    },
                });
                const { notifications, currentPeriod } = response.data.coachTrainee;
                return notifications.map(this.adaptNotificationAction(currentPeriod));
            }
            catch (e) {
                return [];
            }
            // return Promise.resolve([
            //   {
            //     id: "test123",
            //     dismissable: false,
            //     type: CustomerActionType.PLAN_REQUIRES_NUMBER_OF_HANDPALMS_ADJUSTMENT,
            //   },
            //   {
            //     id: "test456",
            //     dismissable: true,
            //     type: CustomerActionType.PLAN_REQUIRES_CALORIE_BUDGET_ADJUSTMENT,
            //     planName: "Running Plan",
            //   },
            // ]);
        };
        this.dismissCustomerAction = async (actionId) => {
            await this.client.post("/graphql", {
                operationName: "dismissNotification",
                query: customerNotificationActions_1.dismissNotificationActionMutation,
                variables: {
                    id: actionId,
                },
            });
        };
        this.adaptNotificationAction = (period) => (apiAction) => {
            const action = {
                ...apiAction,
                type: this.apiActionTypeToCustomerActionType(apiAction.type),
            };
            return this.notificationActionsHandlers[action.type](action, period);
        };
        this.adaptGenericActionNotification = (action) => ({
            id: action.id,
            type: action.type,
            dismissable: action.canBeDismissed,
        });
        this.adaptCalorieChangeNotificationAction = (action, period) => ({
            ...this.adaptGenericActionNotification(action),
            planName: period.plan.fullName,
        });
        this.notificationActionsHandlers = {
            [CustomerInterface_1.CustomerActionType.PLAN_REQUIRES_CALORIE_BUDGET_ADJUSTMENT]: this.adaptCalorieChangeNotificationAction,
            [CustomerInterface_1.CustomerActionType.PLAN_REQUIRES_NUMBER_OF_HANDPALMS_ADJUSTMENT]: this.adaptGenericActionNotification,
        };
        this.apiActionTypeToCustomerActionType = (apiType) => {
            const map = {
                ["PLAN_REQUIRES_CALORIE_BUDGET_ADJUSTMENT"]: CustomerInterface_1.CustomerActionType.PLAN_REQUIRES_CALORIE_BUDGET_ADJUSTMENT,
                ["PLAN_REQUIRES_NUMBER_OF_HANDPALMS_ADJUSTMENT"]: CustomerInterface_1.CustomerActionType.PLAN_REQUIRES_NUMBER_OF_HANDPALMS_ADJUSTMENT,
            };
            return map[apiType];
        };
        this.client = client;
    }
}
exports.default = CustomerNotifications;
//# sourceMappingURL=CustomerNotifications.js.map